declare global {
  interface Window {
    dataLayer: IArguments[]
    gtag?: (...args: unknown[]) => void
  }
}

/**
 * Loads the Google tag (gtag.js) and configures the property.
 * Mirrors the snippet Google gives you for the <head>, run as early as possible.
 */
export function initGoogleAnalytics(measurementId: string) {
  if (!measurementId || typeof window === 'undefined') return

  const src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
  if (document.querySelector(`script[src="${src}"]`)) return

  window.dataLayer = window.dataLayer || []
  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments)
  }
  window.gtag = gtag as unknown as (...args: unknown[]) => void

  gtag('js', new Date())
  gtag('config', measurementId)

  const script = document.createElement('script')
  script.async = true
  script.src = src
  document.head.appendChild(script)
}
